// extracted by mini-css-extract-plugin
export default {"container":"Experience_container__ifRWF","content":"Experience_content__B-H3I"};